import React from 'react'
import { LocalityModal } from 'components'
import { useFilter, useLocalityModal } from 'store'
import { filterProfiles } from 'store/filter/utils'
import { navigate } from '@reach/router'

const LocalityModalContainer = () => {
  const { getOpenModal, setOpenModal, getClickedBy } = useLocalityModal()

  const {
    setField,
    setLocalityField,
    getLocality,
    getLocalities,
    getSlug,
  } = useFilter()

  const locality = getLocality()

  const localities = getLocalities()

  const closeModal = () => {
    setLocalityField('')
    setOpenModal()
  }

  const sendAction = () => {
    const clickedBy = getClickedBy()
    const profileParams = filterProfiles[clickedBy]
    closeModal()
    setField('presetProfile', true)
    navigate(`/busca/${getSlug() || ''}?${profileParams}`)
    window.scrollTo(0, 0)
  }

  React.useEffect(() => {
    setLocalityField('')
    // eslint-disable-next-line
  }, [])

  return (
    <LocalityModal
      closeModal={closeModal}
      opened={getOpenModal()}
      localities={localities}
      locality={locality || ''}
      setLocalityField={setLocalityField}
      setSlug={newSlug => setField('slug', newSlug)}
      sendAction={sendAction}
    />
  )
}

export default LocalityModalContainer
